// Reimplementation of MultiDockTypeFilterm in DockTypeFilter.tsx but with rivet-ui
import { TakeoffSurface } from "@skydio/pbtypes/pbtypes/gen/dock_client/takeoff_surface_pb";
import { ComboBox } from "@skydio/rivet-ui";

import type { ValueType } from "@skydio/core";
import type { Key } from "@skydio/rivet-ui";

type ReadableDockType = {
  readableName: string;
  enumValue: string | ValueType<TakeoffSurface.EnumMap>;
  enumStringName: string;
};

const getTypes = () =>
  Object.entries(TakeoffSurface.Enum).map(
    ([key, value]) =>
      ({
        readableName: value,
        enumValue: value,
        enumStringName: key,
      }) as ReadableDockType
  );

export interface MultiDockTypeFilterProps {
  selectedKeys: Iterable<Key>;
  onSelectionChange: (keys: Set<Key>) => void;
}
const MultiDockTypeFilter = (props: MultiDockTypeFilterProps) => {
  return (
    <ComboBox
      selectionMode="multiple"
      placeholder="Select Dock Types"
      selectedKeys={props.selectedKeys}
      onSelectionChange={props.onSelectionChange}
      items={getTypes()}
      aria-label="Select Dock Types"
    >
      {data => (
        <ComboBox.Item key={data.enumStringName as string} aria-label={data.enumStringName}>
          {data.enumStringName}
        </ComboBox.Item>
      )}
    </ComboBox>
  );
};

export default MultiDockTypeFilter;
